module.exports = __webpack_public_path__ + "static/media/GUIDE_0013_04.64fc746f.webp";